import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Oberhavel() {
  return (
    <LocationPageTemplate
      page={{
        location: "Oberhavel",
        locationSlug: "oberhavel",
        keyword: "Haushaltsauflösung Oberhavel",
        metaTitle:
          "Haushaltsauflösung Oberhavel | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung im Landkreis Oberhavel. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Oberhavel – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909af5008498635e7016f2.jpg",
        localIntro: (
          <>
            <p>
              Der Landkreis Oberhavel, angrenzend an den Norden Berlins,
              zeichnet sich durch seine weitläufigen Gemeinden wie Oranienburg,
              Hohen Neuendorf, Hennigsdorf und Velten aus. Hier überwiegen
              Einfamilienhäuser, Reihenhäuser und Grundstücke mit Nebengelassen,
              was bei einer Entrümpelung oft mehr Platz, aber auch größere
              Mengen an Hausrat bedeutet.
            </p>
            <p>
              Im Gegensatz zur dicht bebauten Innenstadt Berlins sind die
              logistischen Herausforderungen hier oft anderer Natur: Längere
              Anfahrtswege zu Recyclinghöfen, große Keller, vollgestellte
              Garagen oder Schuppen auf dem Grundstück erfordern eine gute
              Planung und ausreichend Transportkapazität.
            </p>
            <p>
              Wir sind regelmäßig im gesamten Landkreis Oberhavel im Einsatz und
              bieten Ihnen auch hier unseren bewährten Service: Von der
              kostenlosen Besichtigung bis zur besenreinen Übergabe, alles aus
              einer Hand und zum garantierten Festpreis.
            </p>
          </>
        ),
        trustText:
          "Ob ein Einfamilienhaus in Hohen Neuendorf oder eine Wohnung in Hennigsdorf – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen in Oberhavel zuverlässig zur Seite.",
        trustQuote:
          "Sehr gute Arbeit bei der Haushaltsauflösung in Oranienburg. Pünktlich, sauber und genau zum vereinbarten Preis.",
        challengesText: (
          <>
            <p>
              Die Entsorgung großer Mengen an Sperrmüll oder Gartenabfällen
              erfordert in Oberhavel oft die Koordination mit den lokalen
              Wertstoffhöfen (AWU). Wir übernehmen die komplette Sortierung und
              fachgerechte Entsorgung für Sie, sodass Sie sich um keine
              Nachweise kümmern müssen.
            </p>
            <p>
              Bei der Räumung von Grundstücken mit Nebengebäuden bringen wir bei
              Bedarf auch größeres Gerät oder Container zum Einsatz, um die
              Arbeiten zügig abzuschließen. Die Diskretion gegenüber Nachbarn in
              ruhigen Wohnsiedlungen ist uns dabei besonders wichtig.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Das Team hat unser Haus in Velten sehr schnell und ordentlich entrümpelt. Toller Service!",
            author: "Kunde aus Velten",
          },
          {
            text: "Sehr freundlich und professionell. Die Wertanrechnung für einige Möbelstücke war sehr fair.",
            author: "Kundin aus Hohen Neuendorf",
          },
          {
            text: "Alles wurde besenrein hinterlassen, genau wie versprochen. Keine versteckten Kosten.",
            author: "Familie aus Birkenwerder",
          },
        ],
        neighbors: [
          { name: "Oranienburg", slug: "oranienburg" },
          { name: "Reinickendorf", slug: "reinickendorf" },
          { name: "Pankow", slug: "pankow" },
        ],
        faqs: [
          {
            q: "Kommen Sie für eine Besichtigung nach Oberhavel?",
            a: "Ja, wir bieten kostenlose und unverbindliche Besichtigungstermine im gesamten Landkreis Oberhavel an.",
          },
          {
            q: "Entrümpeln Sie auch Garagen und Schuppen?",
            a: "Selbstverständlich. Wir räumen komplette Grundstücke inklusive aller Nebengebäude, Keller und Dachböden.",
          },
          {
            q: "Wie lange dauert eine Haushaltsauflösung in der Regel?",
            a: "Eine normale Wohnungsauflösung ist oft an einem Tag erledigt. Bei größeren Häusern planen wir entsprechend mehr Zeit ein, arbeiten aber immer zügig.",
          },
          {
            q: "Nehmen Sie auch alte Elektrogeräte mit?",
            a: "Ja, wir entsorgen alle Arten von Hausrat fachgerecht, einschließlich Elektro-Großgeräten und Sondermüll wie alten Farben.",
          },
        ],
      }}
    />
  );
}
